<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <!-- 编码 -->
      <el-form-item label="使用说明图名称" prop="name">
        <el-input v-model.trim="form.name" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- 线路区分 -->
      <el-form-item label="选择模块使用" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option v-for="item in options" :key="item.type" :label="item.name" :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>
            <!-- 产品图片 -->
      <el-form-item label="使用说明图片" prop="pic">
        <uploadFile :limit="1" :img-list-string="form.pic" @fileChange="uploadChange($event, 'pic')" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  valid
} from 'mockjs'
import {
  FlowchartDetail,
  flowchartUpdate,
  brandAdd,
  Index_country_list
} from '@/api/xgcApi'
import uploadFile from '@/components/uploadFile'
export default {
  name: 'ManageStore',
    components: {
      uploadFile,
    },
  data() {
    return {
      form: {
        id:'',
        name: null,
        pic:'',
        type:''
      },
      rules: {
        name: [{
          required: true,
          trigger: 'blur',
          message: '请输入名称'
        }],
        type: [{
          required: true,
          trigger: 'blur',
          message: '请输入内容'
        }],
      },
      options: [
        {
          type: 0,
          name: '预报'
        },
        {
          type: 1,
          name: '完善 '
        },
        {
          type: 2,
          name: '代买'
        },
        {
          type: 3,
          name: '代付'
        },
      ],
      title: '',
      dialogFormVisible: false,
      isShow: true,
    }
  },
  created() { },
  methods: {


      // 上传图片
      uploadChange(e) {
        var strurl = e.join(',')
        strurl = strurl.replace('\\\\', '\/\/')
        strurl = strurl.replace('\\', '\/')
        strurl = strurl.replace('\\', '\/')
        this.form.pic = strurl
      },

    showEdit(row) {
        this.dialogFormVisible = true
    if (!row) {
          this.title = '添加'
          this.isShow = false
        } else {
          this.isShow = true
          this.title = '编辑'
          // const {
          //   data
          // } = await FlowchartDetail(row.id)
          // this.form = data
          // this.form = Object.assign({}, row)
          FlowchartDetail({id:row.id}).then(req => {
            this.form = req.data
            // this.form = Object.assign({}, row)
          })
        }




    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
      this.$emit('fetch-data')
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (this.isShow == false) {
            const {
              msg
            } = await flowchartUpdate(this.form)
            this.$baseMessage(msg, 'success')
            this.$refs['form'].resetFields()
            this.dialogFormVisible = false
            this.$emit('fetch-data')
            this.form = this.$options.data().form
          } else {
            const {
              msg
            } = await flowchartUpdate(this.form)
            this.$baseMessage(msg, 'success')
            this.$refs['form'].resetFields()
            this.dialogFormVisible = false
            this.$emit('fetch-data')
            // this.form = this.$options.data().form
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
